var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpRecon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0337 12.0334C4.0337 7.61516 7.61542 4.03344 12.0337 4.03344C16.452 4.03344 20.0336 7.61516 20.0336 12.0334C20.0336 16.4517 16.452 20.0334 12.0337 20.0334C7.61542 20.0334 4.0337 16.4517 4.0337 12.0334ZM12.0337 0.0334473C5.40628 0.0334473 0.0336914 5.40604 0.0336914 12.0334C0.0336914 18.6609 5.40628 24.0334 12.0337 24.0334C14.6254 24.0334 17.0251 23.2118 18.9868 21.815L24.5528 27.381C25.3338 28.162 26.6002 28.162 27.3812 27.381C28.1622 26.5998 28.1622 25.3336 27.3812 24.5526L21.8152 18.9865C23.2122 17.0249 24.0336 14.6251 24.0336 12.0334C24.0336 5.40604 18.6611 0.0334473 12.0337 0.0334473Z",
    fill: "url(#paint0_linear_3_198)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_198",
    x1: 4.84188,
    y1: 16.9023,
    x2: 27.7914,
    y2: 17.2602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3965FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#0071F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#0096F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E6F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpRecon);
export default __webpack_public_path__ + "static/media/exp-recon.bcfcde822766710053b60353c2436bd8.svg";
export { ForwardRef as ReactComponent };